import juniAxios from 'services/axios';

export async function getLoggedInParent(withStudents = false) {
  return (
    await juniAxios.get(`/learner/parent${withStudents ? '?withStudents=true' : ''}`)
  ).data.data;
}
